import { Injectable } from '@angular/core';
import { IShipmentLocationRequest } from '@cemex-core/cmx-api';
import { Store } from '@ngrx/store';
import { filter, map, switchMap } from 'rxjs/operators';
import CxShipmentLocationAction from './store/actions/cx-shipment-location.actions';
import { CxShipmentLocationState } from './store/reducers/cx-shipment-location.reducer';
import * as cxShipmentLocationSelector from './store/selectors/cx-shipment-location.selector';
import { CxApiMetadataService, CxApiMetadataStrategy } from '../cx-api-metadata/cx-api-metadata.service';
import { CxApiMetadataEntity } from '../cx-api-metadata/store/reducers/cx-api-metadata.reducer';
import { CxShipmentLocation } from './models/shipment-location';

@Injectable()
export class CxShipmentLocationService {
  constructor(
    private store: Store<CxShipmentLocationState>,
    private cxApiMetadata: CxApiMetadataService,
  ) {}

  public selectShipmentLocations$(productTypeRequest: IShipmentLocationRequest, strategy?: CxApiMetadataStrategy) {
    return this.cxApiMetadata.connectMetadata$(CxShipmentLocationAction.fetchEntity(productTypeRequest), strategy).pipe(
      switchMap((metadata) =>
        this.store.select(cxShipmentLocationSelector.selectCxShipmentLocationsById(), { ids: metadata.entityIds }).pipe(
          filter((res) => res.length === metadata.entityIds.length),
          map((res) => [res, metadata] as [CxShipmentLocation[], CxApiMetadataEntity]),
        ),
      ),
    );
  }

  public selectActive$() {
    return this.store.select(cxShipmentLocationSelector.selectActiveCxShipmentLocation);
  }

  public setActive(entityId: string | number) {
    return this.store.dispatch(CxShipmentLocationAction.selectEntity({ id: `${entityId}` }));
  }
}
